import React from 'react';
import coupleHumans from './assets/couplehumans.svg';
import badge from './assets/badge.svg';
import twohuman from './assets/twohuman.svg';
import hammer from './assets/hammer.svg';

const WhyChooseUs = () => {
    const advantages = [
        { text: "20+ Years of Experience in Construction" },
        { text: "On-Time, On-Budget Project Delivery" },
        { text: "Quality Materials. Skilled Workforce." },
        { text: "End-to-End Construction Solutions" },
        { text: "ISO Certified. Safety-First Approach" },
    ];

    return (
        <section className="w-full min-h-[90vh] overflow-hidden py-6 sm:py-8 md:py-10 px-4 sm:px-6 md:px-10 lg:px-16 bg-white font-epilogue flex items-center justify-center">

            <div className="max-w-[1440px] w-full h-full bg-[#262626] rounded-[2rem] sm:rounded-[2.5rem] md:rounded-[3rem] p-5 sm:p-6 md:p-8 lg:px-16 lg:py-10 flex flex-col lg:flex-row gap-8 sm:gap-10 lg:gap-16 items-center">

                <div className="w-full lg:w-[55%] flex flex-col justify-center">
                    <div className="bg-[#444444] text-white/90 text-[10px] font-bold uppercase tracking-widest px-4 py-1.5 rounded-full mb-4 sm:mb-6 w-fit">
                        Our Advantages
                    </div>

                    <h2 className="text-3xl sm:text-4xl lg:text-4xl xl:text-4xl font-bold text-white mb-3 sm:mb-4 tracking-tight leading-tight">
                        Why Choose Us
                    </h2>

                    <p className="text-gray-300 text-sm sm:text-base md:text-md mb-6 sm:mb-8 max-w-full sm:max-w-xl leading-relaxed">
                        We combine experience, craftsmanship, and commitment to deliver exceptional results on every project.
                    </p>

                    <div className="relative flex flex-col gap-5 sm:gap-6">
                        <div className="absolute left-[14px] top-4 bottom-4 w-[1px] bg-gray-500/40" />

                        {advantages.map((item, index) => (
                            <div key={index} className="flex items-start sm:items-center gap-4 sm:gap-6 relative">
                                <div className="z-10 w-[28px] h-[28px] sm:w-[30px] sm:h-[30px] flex-shrink-0 flex items-center justify-center bg-[#262626]">
                                    <div className="text-base sm:text-lg">
                                        {index === 0 && "🛠️"}
                                        {index === 1 && "📍"}
                                        {index === 2 && "✅"}
                                        {index === 3 && "🧱"}
                                        {index === 4 && "🏆"}
                                    </div>
                                </div>
                                <p className="text-white text-sm sm:text-md lg:text-lg font-base leading-snug">
                                    {item.text}
                                </p>
                            </div>
                        ))}
                    </div>
                </div>

                <div className="w-full lg:w-[50%] flex flex-col sm:flex-row gap-4 sm:gap-5 items-stretch">

                    <div className="flex-1 flex flex-col gap-4">
                        <div className="bg-[#D9F96B] rounded-[1.5rem] sm:rounded-[2rem] p-5 sm:p-6 pb-0 flex-grow basis-3/5 relative overflow-hidden flex flex-col w-full sm:w-[95%] md:w-[90%]">
                            <h3 className="text-lg sm:text-xl md:text-2xl font-semibold text-black leading-tight mb-2">
                                20+ year of <br /> experience
                            </h3>
                            <div className="flex-grow -mx-4 sm:-mx-6 relative translate-y-6">
                                <img
                                    src={coupleHumans}
                                    alt="Experience"
                                    className="w-full h-full object-cover object-bottom"
                                />
                            </div>
                        </div>

                        <div className="bg-[#65F0A4] rounded-t-[1.5rem] sm:rounded-t-[2rem] p-5 sm:p-6 min-h-[200px] xl:min-h-[300px] sm:min-h-[240px] flex flex-col items-center text-center w-full sm:w-[95%] md:w-[90%] xl:translate-y-10">
                            <h3 className="text-base sm:text-lg font-semibold text-black mb-2">ISO certified</h3>
                            <div className="flex-grow flex items-center justify-center w-full">
                                <img
                                    src={badge}
                                    alt="ISO Badge"
                                    className="w-[70px] sm:w-[90px] md:w-[140px] h-auto object-contain"
                                />
                            </div>
                        </div>
                    </div>

                    <div className="flex-1 flex flex-col gap-4 items-end">
                        <div className="bg-[#FF8A7A] rounded-b-[1.5rem] sm:rounded-b-[2rem] flex-grow basis-1/3 relative overflow-hidden w-full sm:w-[95%] md:w-[90%] xl: -translate-y-10">
                            <div className="w-full h-full flex items-end justify-center translate-y-6">
                                <img
                                    src={twohuman}
                                    alt="Handshake"
                                    className="w-full h-full object-cover object-bottom"
                                />
                            </div>
                        </div>

                       <div className="bg-[#F2F2F2] rounded-[1.5rem] sm:rounded-[2rem] pt-6 sm:pt-8 px-5 sm:px-6 flex flex-col overflow-hidden flex-grow basis-2/3 w-full sm:w-[95%] md:w-[90%] relative">
    <div className="absolute top-[10%] left-1/2 -translate-x-1/2 -translate-y-1/2 w-[130%] aspect-square rounded-full bg-[#EBEBEB]" />
    <div className="absolute top-[10%] left-1/2 -translate-x-1/2 -translate-y-1/2 w-[110%] aspect-square rounded-full bg-[#E4E4E4]" />
    <div className="absolute top-[10%] left-1/2 -translate-x-1/2 -translate-y-1/2 w-[90%] aspect-square rounded-full bg-[#DDDDDD]" />
    <h3 className="text-base sm:text-lg md:text-md font-semibold text-gray-900 leading-tight mb-3 sm:mb-4 relative z-10 text-center w-full whitespace-nowrap">
        Quality Materials <br /> Skilled Workforce
    </h3>
    <div className="flex-grow -mx-4 sm:-mx-6 relative z-10">
        <img
            src={hammer}
            alt="Construction Materials"
            className="w-full h-full object-cover"
        />
    </div>
</div>
                    </div>

                </div>
            </div>
        </section>
    );
};

export default WhyChooseUs;